// extracted by mini-css-extract-plugin
module.exports = {"content":"ColumnBody_content__3B8Ru","card":"ColumnBody_card__3hRlh","draggingCard":"ColumnBody_draggingCard__1AcRh"};